// extracted by mini-css-extract-plugin
export default {"topPicks":"topPicks__MWI4M"};